import { render, staticRenderFns } from "./VisualizarAnexo.vue?vue&type=template&id=1a0f0122"
import script from "./VisualizarAnexo.vue?vue&type=script&lang=js"
export * from "./VisualizarAnexo.vue?vue&type=script&lang=js"
import style0 from "./VisualizarAnexo.vue?vue&type=style&index=0&id=1a0f0122&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports